var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.82 17.0885C19.2628 17.0885 22.8644 13.487 22.8644 9.04425C22.8644 4.60151 19.2628 1 14.82 1C10.3773 1 6.77579 4.60151 6.77579 9.04425C6.77579 13.487 10.3773 17.0885 14.82 17.0885Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6401 33.1773C28.6401 26.9509 22.446 21.9152 14.8201 21.9152C7.19408 21.9152 1 26.9509 1 33.1773",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9944 31.4379C20.003 31.4379 20.8207 30.6203 20.8207 29.6117C20.8207 28.603 20.003 27.7854 18.9944 27.7854C17.9858 27.7854 17.1681 28.603 17.1681 29.6117C17.1681 30.6203 17.9858 31.4379 18.9944 31.4379Z",
    stroke: "white",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34125 27.0027V22.8284",
    stroke: "white",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7335 28.0463V22.8284",
    stroke: "white",
    strokeWidth: 1.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2547 32.7424C13.2547 32.4525 14.2834 32.6891 14.2549 32.4097C13.9423 29.3531 11.9765 27.0027 9.60213 27.0027C7.22777 27.0027 5.26197 29.3531 4.94932 32.4097C4.92072 32.6891 5.94959 32.4525 5.94959 32.7424",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step-3.2c10b328a5bf28b9e6b0bad5001f449b.svg";
export { ForwardRef as ReactComponent };